var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.10043 4.10048C5.87978 4.32113 5.87978 4.67887 6.10043 4.89951L9.20091 8L6.10043 11.1005C5.87978 11.3211 5.87978 11.6789 6.10043 11.8995C6.32107 12.1202 6.67881 12.1202 6.89946 11.8995L10.3995 8.39951C10.5054 8.29355 10.5649 8.14985 10.5649 8C10.5649 7.85015 10.5054 7.70644 10.3995 7.60048L6.89946 4.10048C6.67881 3.87984 6.32107 3.87984 6.10043 4.10048Z","fill":"currentColor"}));
}

ArrowInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
